import React from "react"
import styled from "styled-components"
import { Paragraph } from "components/_blueprint/Typography"
import LegalAndGeneralPng from "url:assets/images/legal-and-general.png"
import { desktop, mobile, tablet } from "components/_blueprint/Layout"

export const LegalAndGeneral = () => (
  <Container>
    <BigTextBlock>
      <BigText>
        What are the chances... you could die, get a critical illness or be unable to work for 4
        weeks or more before reaching retirement age?
      </BigText>
      <LegalAndGeneralLogo src={LegalAndGeneralPng}></LegalAndGeneralLogo>
    </BigTextBlock>
    <Paragraph weight={400}>
      With the help of Legal & General, one of the UK's best known and leading mortgage and life
      protection providers, we have compared your information against UK population and insurer
      claims statistics to estimate the likelihood of these life events.
    </Paragraph>
  </Container>
)

const Container = styled.div({
  maxWidth: 1400,
  margin: "0 auto",
  padding: "16px",
})

const BigTextBlock = styled.div({
  display: "flex",
  padding: "0 0 32px",

  [mobile]: {
    flexDirection: "column-reverse",
    gap: "40px",
  },
  [tablet]: {
    flexDirection: "row",
    gap: "40px",
  },
  [desktop]: {
    flexDirection: "row",
    gap: "40px",
  },
})

const BigText = styled.p({
  maxWidth: 900,
  fontSize: "36px",
  fontWeight: 700,
  flex: 1,
  margin: 0,

  [mobile]: {
    fontSize: "24px",
  },
  [tablet]: {
    fontSize: "24px",
  },
  [desktop]: {
    fontSize: "36px",
  },
})

const LegalAndGeneralLogo = styled.img({
  width: "125px",
  height: "93px",

  [mobile]: {
    margin: "0 auto",
  },
  [tablet]: {
    margin: "0 0 0 auto",
  },
  [desktop]: {
    margin: "0 0 0 auto",
  },
})
